import styled from 'styled-components';

import Attachment from 'models/Attachment';
import { colors } from 'styles/theme/colors';
import ErrorWarningIcon from 'svg/ErrorWarningIcon';

type Props = {
  attachments: Attachment[];
  context: string;
};

export default function ErroredAttachmentsBanner({ attachments, context }: Props) {
  if (attachments.length === 0) return null;

  return (
    <Container>
      <ErrorWarningIcon />
      <Text>
        <span>The following file(s) failed to process and are not included in the {context}:</span>
        <List>
          {attachments.map((attachment) => (
            <li key={attachment.id}>{attachment.filename}</li>
          ))}
        </List>
      </Text>
    </Container>
  );
}

const Container = styled.div`
  border: 1px solid ${colors.red25};
  background-color: ${colors.red10};
  border-radius: 4px;
  padding: 16px;
  font-size: 12px;

  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 8px;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 4px;
  }
`;
